import React from 'react';

import { Box } from '@mui/material';

import { Nullable } from '@clearverify/types';
import { numberWithCommas } from '@clearverify/utils';

import { DashboardCvAdminVerifiersDataResponseInfoFragment } from 'src/api';
import { useDashboardPrintView } from 'src/hooks/dashboard';
import { SxProp } from 'src/types/mui';

import { DashboardCard } from './DashboardCard';

export type DashboardVerifiersBlockProps = {
  dashboardVerifiersData: Nullable<DashboardCvAdminVerifiersDataResponseInfoFragment>;
  loading?: boolean;
};

export const DashboardVerifiersBlock: React.FC<DashboardVerifiersBlockProps> = ({
  dashboardVerifiersData,
  loading,
}) => {
  const { isPrintView } = useDashboardPrintView();

  return (
    <Box sx={dashboardVerifiersBlockBoxStyles(isPrintView)}>
      <DashboardCard
        title="Average Verifier Certification Time"
        description="Hours"
        value={String(numberWithCommas(dashboardVerifiersData?.averageCertificationHours))}
        loading={loading}
      />
      <DashboardCard
        title="Commercial Verifiers"
        description="Count of Commercial Verifiers on Platform"
        value={String(numberWithCommas(dashboardVerifiersData?.commercialVerifiersCount))}
        loading={loading}
      />
      <DashboardCard
        title="Governmental Verifiers"
        description="Count of Governmental Verifiers on Platform"
        value={String(numberWithCommas(dashboardVerifiersData?.governmentalVerifiersCount))}
        loading={loading}
      />
    </Box>
  );
};

const dashboardVerifiersBlockBoxStyles =
  (isPrintView: boolean): SxProp =>
  theme => ({
    display: 'grid',
    mt: 4,
    gap: 2,
    gridTemplateColumns: 'repeat(3, 1fr)',
    overflow: 'auto',

    [theme.breakpoints.down('md')]: !isPrintView
      ? {
          gridTemplateColumns: 'none',
        }
      : {},
  });
